/* eslint-disable react-perf/jsx-no-new-function-as-prop,jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Link, LinkButton } from 'app/shared/ui';
import { tracking } from 'app/marketplace/SlideInBanners/SweepstakesBanner/SweepstakesBanner.tracking';
import { useSlideIn } from 'app/marketplace/SlideInBanners/shared/hooks/desktop/useSlideIn';
import { color } from 'app/shared/styles_js/variables';
import { noop } from 'app/shared/utils/utils';

import {
  TextSt,
  ImageSt,
  ModalSt,
  HeadingSt,
  BoldTextSt,
  IconCloseSt,
  CtasWrapperSt,
  ImageWrapperSt,
  ModalWrapperSt,
  ContentWrapperSt,
} from './SweepstakesBanner.css';

export const SweepstakesBanner = ({
  onClose,
  threshold,
  areCookiesAccepted,
}) => {
  const [mode, changedToVisible] = useSlideIn(threshold);

  useEffect(() => {
    if (changedToVisible) {
      tracking.render();
    }
  }, [changedToVisible]);

  const handleCloseIconClick = () => {
    tracking.closeIcon();

    onClose(areCookiesAccepted);
  };

  const handleCloseLinkClick = () => {
    tracking.closeLink();
    onClose(areCookiesAccepted);
  };

  const handleCtaClick = () => {
    tracking.ctaClick();
    onClose(areCookiesAccepted);
  };

  return (
    <ModalSt mode={mode}>
      <IconCloseSt
        className="if-icon-close"
        onClick={handleCloseIconClick}
        color={color.white}
      />
      <ModalWrapperSt>
        <HeadingSt>Top-Autos zu gewinnen!</HeadingSt>
        <ContentWrapperSt>
          <div>
            <TextSt color={color.white}>
              <BoldTextSt>Nur noch bis zum 20.12.2020:</BoldTextSt>
              Sichere dir die Chance auf einen Gebrauchtwagen beim heycar
              Gewinnspiel.
            </TextSt>
          </div>
          <ImageWrapperSt>
            <ImageSt src="/assets/slide-in-sweepstakes-desktop.png" />
          </ImageWrapperSt>
        </ContentWrapperSt>
        <CtasWrapperSt>
          <div>
            <Link
              onClick={handleCloseLinkClick}
              color={color.brandPrimary}
              hoverColor={color.white}
              fontWeight="bold"
            >
              Gerade nicht
            </Link>
          </div>
          <div>
            <LinkButton to="/gewinnspiel" onClick={handleCtaClick}>
              Jetzt teilnehmen
            </LinkButton>
          </div>
        </CtasWrapperSt>
      </ModalWrapperSt>
    </ModalSt>
  );
};

SweepstakesBanner.propTypes = {
  onClose: PropTypes.func,
  threshold: PropTypes.number,
  areCookiesAccepted: PropTypes.bool,
};

SweepstakesBanner.defaultProps = {
  onClose: noop,
  threshold: 1,
  areCookiesAccepted: false,
};
